import { getMostUrgentState, type TaskHubItemState } from '../utils/taskHubItemState';
import type { SurfacedAsyncItem } from './getSurfacedAsyncItems';

/** The most urgent state among the given surfaced items, or `undefined` when there are none. */
export function getMostUrgentItemState(items: SurfacedAsyncItem[]): TaskHubItemState | undefined {
    return getMostUrgentState(items.map(({ state }) => state));
}
